const EXPIRATION_KEY = 'local_storage_expiration'

export const getKeyQuestionByAction = (action: string, payload: any) => {
  let key =
    payload.currentUserId + '_' + payload.skillId + '_question_' + action

  if (payload.parentQuestionId) {
    key += '_' + payload.parentQuestionId
  }

  if (payload.questionId) {
    key += '_' + payload.questionId
  }

  return key
}

export const getKeyAnswerByAction = (action: string, payload: any) => {
  let key =
    payload.currentUserId + '_' + payload.questionId + '_answer_' + action

  if (payload.commentId) {
    key += '_' + payload.commentId
  }

  return key
}

export const createData = (key: string, data: string) => {
  window.localStorage.setItem(key, data)
}

export const getData = (key: string) => {
  return window.localStorage.getItem(key)
}

export const removeData = (key: string) => {
  window.localStorage.removeItem(key)
}

// expiresAt is a timestamp in seconds
const createOrUpdateExpiration = (key: string, expiresAt: number) => {
  const expirationData = getData(EXPIRATION_KEY)
  if (expirationData) {
    const expirationObject = JSON.parse(expirationData)
    expirationObject[key] = expiresAt
    createData(EXPIRATION_KEY, JSON.stringify(expirationObject))
  } else {
    createData(EXPIRATION_KEY, JSON.stringify({ [key]: expiresAt }))
  }
}

export const clearExpiredData = () => {
  const expirationData = getData(EXPIRATION_KEY)
  if (expirationData) {
    const expirationObject = JSON.parse(expirationData)
    for (const key in expirationObject) {
      if (expirationObject[key] < Math.round(Date.now() / 1000)) {
        removeData(key)
        delete expirationObject[key]
      }
    }
    createData(EXPIRATION_KEY, JSON.stringify(expirationObject))
  }
}

export const createDataWithExpiration = (
  key: string,
  data: string,
  expiration?: number // timestamp in seconds
) => {
  createData(key, data)
  if (expiration) {
    createOrUpdateExpiration(key, Math.round(Date.now() / 1000 + expiration))
  }
}

export const removeDataWithExpiration = (key: string) => {
  removeData(key)
  const expirationData = getData(EXPIRATION_KEY)
  if (expirationData) {
    const expirationObject = JSON.parse(expirationData)
    delete expirationObject[key]
    createData(EXPIRATION_KEY, JSON.stringify(expirationObject))
  }
}
export interface LocalStorageUtils {
  getKeyQuestionByAction: typeof getKeyQuestionByAction
  getKeyAnswerByAction: typeof getKeyAnswerByAction
  createData: typeof createData
  getData: typeof getData
  removeData: typeof removeData
  removeDataWithExpiration: typeof removeDataWithExpiration
  createDataWithExpiration: typeof createDataWithExpiration
  clearExpiredData: typeof clearExpiredData
}
